<template>
  <v-navigation-drawer permanent app clipped v-if="!isPublicPage">
    <v-list dense nav>
      <template v-for="(section, index) in menus">
        <template v-for="item in section">
          <v-list-item
            :key="item.text"
            link
            :to="{ name: item.to }"
            color="primary"
            exact
            v-if="item.to"
          >
            <v-list-item-content>
              <v-list-item-title>{{ item.text }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            :key="item.text"
            link
            :href="item.href"
            color="primary"
            exact
            v-if="item.href"
            target="_blank"
          >
            <v-list-item-content>
              <v-list-item-title>{{ item.text }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
        <v-divider :key="index"></v-divider>
      </template>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { menus } from "@/utilities/constants-utility";
export default {
  data() {
    return {
      menus,
    };
  },
  computed: {
    isPublicPage() {
      return this.$route.meta.publicPage;
    },
  },
};
</script>

<style></style>
